import { InputField } from '@sonnen/web-ui';
import { useAuth } from '@sonnen/web-utils/hooks';
import { useEffect, useRef, useState } from 'react';
import { AppRoute } from '../../constants';
import { useCurrentRoute } from '../../hooks/useCurrentRoute';
import { useOfferContext } from '../../OfferContext/OfferContext';
import styles from './InputField.module.css';

const inputKey = import.meta.env.VITE_HONEYPOT_KEY;

export const waitingTime: Partial<Record<AppRoute, number>> = {
  [AppRoute.DATA_ENTRY]: 8000,
};

const HoneypotField = () => {
  const { authenticated } = useAuth();
  const { setWorkEmail } = useOfferContext();
  const [inputTrap, setInputTrap] = useState<string>('');
  const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
  const currentRoute = useCurrentRoute();
  const delay = waitingTime[currentRoute] || 2000;
  const componentMountTimestamp = useRef(Date.now());

  const waitForUser = () => {
    // set the secret only after the user has interacted with the page after a given delay,
    // to catch bots that fill out the field immediately.
    const minimumInputTimeDelay = new Date().getTime() > componentMountTimestamp.current + delay;
    if (minimumInputTimeDelay && inputTrap === '') setWorkEmail(inputKey);
  };

  useEffect(() => {
    if (!authenticated) {
      componentMountTimestamp.current = Date.now();
      events.forEach((userEvent) => window.addEventListener(userEvent, waitForUser));
      return () => {
        events.forEach((event) => window.removeEventListener(event, waitForUser));
      };
    }
  }, [authenticated]);

  useEffect(() => {
    // regardless of when this happens, if input changed, we caught the bot in the Honeypot
    if (inputTrap !== '') setWorkEmail(inputTrap);
    return () => {
      events.forEach((event) => window.removeEventListener(event, waitForUser));
    };
  }, [inputTrap]);

  if (authenticated || navigator.userAgent.includes('Edg')) return;

  return (
    <InputField
      dataTestId="question"
      label=""
      maxLength={60}
      name="question"
      onChange={(_, val) => setInputTrap(val)}
      value={inputTrap}
      className={styles.workEmail}
      tabIndex={-1}
      ariaAutocomplete="none"
      aria-hidden="true"
    />
  );
};

export default HoneypotField;
